import React from "react";

const Announcement = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M9.62 24.128h.06c.359 0 .64-.317.64-.704V11.362c0-.388-.281-.705-.64-.705H4.017c-1.107 0-2.016 1-2.016 2.227v9.025c0 1.219.909 2.22 2.016 2.22h.373l2.29 6.862c.345 1.029 1.248 1.726 2.246 1.726.282 0 .557-.056.826-.162l.122-.05c.595-.246 1.075-.732 1.344-1.366a2.839 2.839 0 0 0 .07-2.015L9.62 24.128ZM29.232 3.027a.61.61 0 0 0-.716.303c-3.034 5.333-8.25 8.518-13.966 8.518H11.6v11.09h2.95c5.709 0 10.925 3.177 13.96 8.518l.005.007a.635.635 0 0 0 .538.324.567.567 0 0 0 .186-.028c.268-.092.454-.367.454-.677V3.703c0-.31-.186-.592-.46-.676ZM30.972 12.375v10.037C32.749 21.586 34 19.648 34 17.394s-1.25-4.192-3.028-5.019Z"
            fill={fill}
        />
    </svg>
);

export default Announcement;
